import axios from 'axios';
import {
    PARTNERSHIP_API,
    API_HEADER
} from '../../../constants/API'
import {
    GET_PARTNERSHIP_PRODUCTS_LOADING,
    GET_PARTNERSHIP_PRODUCTS
} from '../types';
import { message } from 'antd';

export default (id) => {
    return async (dispatch, getState) => {
        try {
            dispatch({
                type: GET_PARTNERSHIP_PRODUCTS_LOADING,
                partnershipProductsLoading: true
            })
            const { token } = getState().UserReducer;
            const partnershipProductsResponse = await axios.get(`${PARTNERSHIP_API}/products/${id}`, API_HEADER(token))
            dispatch({
                type: GET_PARTNERSHIP_PRODUCTS,
                partnershipProductsLoading: false,
                partnershipProducts: partnershipProductsResponse.data
            })
        } catch (e) {
            if (e && e.response && e.response.data) {
                message.error(String(e.response.data))
            }
            dispatch({
                type: GET_PARTNERSHIP_PRODUCTS_LOADING,
                partnershipProductsLoading: false
            })

        }
    }
}